// 10 Farklı Uzay Filosu ve Profesyonel Evrim Aşamaları
export const EVOLUTION_CHAINS = [
    ["Hafif Avcı", "Savaş Gemisi", "Yıldız Kruvazörü"],           // 1. Savaş (Kırmızı / Altın)
    ["Kargo Kapsülü", "Ticaret Gemisi", "Galaktik Taşıyıcı"],     // 2. Ticaret (Turuncu / Turkuaz)
    ["Keşif Sondası", "Uzay Gezgini", "Derin Uzay Gemisi"],        // 3. Keşif (Kraliyet Mavisi / Camgöbeği)
    ["Maden Dronu", "Asteroit Kazıcı", "Dev Maden Gemisi"],       // 4. Maden (Kehribar / Gümüş)
    ["Kurtarma Kapsülü", "Medikal Gemi", "Şifa Kruvazörü"],       // 5. Kurtarma (Zümrüt Yeşili)
    ["Devriye Sondası", "Savunma Gemisi", "Kalkan Kruvazörü"],     // 6. Savunma (Titanyum Gri / Mavi)
    ["Hayalet Sonda", "Gizli Gemi", "Kamuflaj Kruvazörü"],        // 7. Gizlilik (Gece Moru / Neon Pembe)
    ["Haberci Kapsül", "Hız Gemisi", "Işık Hızı Jeti"],           // 8. Hız (Neon Turkuaz)
    ["Gözlem Sondası", "Laboratuvar Gemisi", "Bilim Kruvazörü"],   // 9. Araştırma (Magenta / Mor)
    ["Taktik Mekik", "Komuta Gemisi", "Amiral Gemisi"]            // 10. Komuta (Saf Beyaz / Altın)
];

// Gelişmiş, Profesyonel SVG Çizim Motoru
export const getPokemonImage = (idOrName) => {
    let primary = "#2563eb", secondary = "#1e3a8a", accent = "#bae6fd", engine = "#60a5fa", detail = "rgba(0,0,0,0.15)";
    let level = 1;

    // 1. AŞAMA: PREMIUM RENK PALETLERİ
    if (["Hafif Avcı", "Savaş Gemisi", "Yıldız Kruvazörü"].includes(idOrName)) { 
        primary = "#dc2626"; secondary = "#7f1d1d"; accent = "#fef08a"; engine = "#f97316"; // Savaş
    } else if (["Kargo Kapsülü", "Ticaret Gemisi", "Galaktik Taşıyıcı"].includes(idOrName)) { 
        primary = "#ea580c"; secondary = "#7c2d12"; accent = "#e0f2fe"; engine = "#fcd34d"; // Ticaret
    } else if (["Keşif Sondası", "Uzay Gezgini", "Derin Uzay Gemisi"].includes(idOrName)) { 
        primary = "#2563eb"; secondary = "#172554"; accent = "#7dd3fc"; engine = "#38bdf8"; // Keşif
    } else if (["Maden Dronu", "Asteroit Kazıcı", "Dev Maden Gemisi"].includes(idOrName)) { 
        primary = "#ca8a04"; secondary = "#713f12"; accent = "#f8fafc"; engine = "#fef08a"; // Maden
    } else if (["Kurtarma Kapsülü", "Medikal Gemi", "Şifa Kruvazörü"].includes(idOrName)) { 
        primary = "#059669"; secondary = "#022c22"; accent = "#a7f3d0"; engine = "#34d399"; // Kurtarma
    } else if (["Devriye Sondası", "Savunma Gemisi", "Kalkan Kruvazörü"].includes(idOrName)) { 
        primary = "#475569"; secondary = "#1e293b"; accent = "#e0f2fe"; engine = "#38bdf8"; // Savunma
    } else if (["Hayalet Sonda", "Gizli Gemi", "Kamuflaj Kruvazörü"].includes(idOrName)) { 
        primary = "#7c3aed"; secondary = "#4c1d95"; accent = "#fbcfe8"; engine = "#c084fc"; // Gizlilik
    } else if (["Haberci Kapsül", "Hız Gemisi", "Işık Hızı Jeti"].includes(idOrName)) { 
        primary = "#0891b2"; secondary = "#164e63"; accent = "#cffafe"; engine = "#22d3ee"; // Hız
    } else if (["Gözlem Sondası", "Laboratuvar Gemisi", "Bilim Kruvazörü"].includes(idOrName)) { 
        primary = "#db2777"; secondary = "#831843"; accent = "#fce7f3"; engine = "#f472b6"; // Araştırma
    } else if (["Taktik Mekik", "Komuta Gemisi", "Amiral Gemisi"].includes(idOrName)) { 
        primary = "#f8fafc"; secondary = "#94a3b8"; accent = "#fcd34d"; engine = "#fbbf24"; // Komuta (Beyaz/Altın)
    }

    // 2. AŞAMA: PUANA GÖRE GÖVDE TİPİNİ BELİRLE
    if (["Yıldız Kruvazörü", "Galaktik Taşıyıcı", "Derin Uzay Gemisi", "Dev Maden Gemisi", "Şifa Kruvazörü", "Kalkan Kruvazörü", "Kamuflaj Kruvazörü", "Işık Hızı Jeti", "Bilim Kruvazörü", "Amiral Gemisi"].includes(idOrName)) {
        level = 3; // Dev Kruvazörler (20+ Puan)
    } else if (["Savaş Gemisi", "Ticaret Gemisi", "Uzay Gezgini", "Asteroit Kazıcı", "Medikal Gemi", "Savunma Gemisi", "Gizli Gemi", "Hız Gemisi", "Laboratuvar Gemisi", "Komuta Gemisi"].includes(idOrName)) {
        level = 2; // Gelişmiş Avcı Gemileri (10-19 Puan)
    }

    // 3. AŞAMA: PROFESYONEL VEKTÖR ÇİZİMLERİ
    let svgContent = '';
    if (level === 1) {
        // Seviye 1: Ok (Dart) tasarımlı şık gözlem/keşif araçları
        svgContent = `
            <!-- Motor Alevi -->
            <path d="M46 68 L50 82 L54 68 Z" fill="${engine}" />
            <path d="M48 68 L50 75 L52 68 Z" fill="#fff" />
            <!-- Kanatlar -->
            <path d="M50 15 L62 45 L68 65 L50 60 L32 65 L38 45 Z" fill="${primary}" stroke="${secondary}" stroke-width="2.5" stroke-linejoin="round"/>
            <!-- Gövde Detay ve Zırhı -->
            <path d="M50 20 L58 45 L62 60 L50 55 L38 60 L42 45 Z" fill="${detail}"/>
            <path d="M50 15 L50 60" stroke="${secondary}" stroke-width="1.5" stroke-opacity="0.5"/>
            <!-- Kokpit Camı -->
            <path d="M50 32 L54 42 L50 48 L46 42 Z" fill="${accent}" stroke="${secondary}" stroke-width="1.5"/>
            <path d="M50 34 L52 42 L50 46 Z" fill="#fff" opacity="0.6"/> <!-- Cam parlaması -->
        `;
    } else if (level === 2) {
        // Seviye 2: Delta kanatlı, agresif görünümlü, çift motorlu avcı gemisi
        svgContent = `
            <!-- Çift Motor Alevi -->
            <path d="M34 72 L38 90 L42 72 Z" fill="${engine}" />
            <path d="M58 72 L62 90 L66 72 Z" fill="${engine}" />
            <!-- Ana Gövde ve Geriye Kıvrık Kanatlar -->
            <path d="M50 8 L72 52 L84 75 L60 68 L50 78 L40 68 L16 75 L28 52 Z" fill="${primary}" stroke="${secondary}" stroke-width="2.5" stroke-linejoin="round"/>
            <!-- İç Zırh Plakaları (Derinlik algısı) -->
            <path d="M50 18 L65 52 L74 70 L60 64 L50 70 L40 64 L26 70 L35 52 Z" fill="${detail}"/>
            <path d="M50 8 L50 78" stroke="${secondary}" stroke-width="1.5" stroke-opacity="0.4"/>
            <!-- Merkez İtici veya Jeneratör (Ortada) -->
            <polygon points="45 68 55 68 50 75" fill="${engine}" opacity="0.8"/>
            <!-- Geniş Kokpit -->
            <path d="M50 30 L56 46 L50 56 L44 46 Z" fill="${accent}" stroke="${secondary}" stroke-width="1.5"/>
            <path d="M50 32 L54 46 L50 54 Z" fill="#fff" opacity="0.5"/>
        `;
    } else {
        // Seviye 3: Korkutucu, devasa, katmanlı zırha sahip Ağır Kruvazör
        svgContent = `
            <!-- 4'lü Ağır Motor Alevi -->
            <path d="M22 80 L26 102 L30 80 Z" fill="${engine}" />
            <path d="M38 82 L44 110 L50 85 Z" fill="${engine}" />
            <path d="M62 82 L56 110 L50 85 Z" fill="${engine}" />
            <path d="M78 80 L74 102 L70 80 Z" fill="${engine}" />
            <!-- Dev Gövde Dış Hatları -->
            <path d="M50 5 L68 35 L88 60 L94 85 L72 78 L50 90 L28 78 L6 85 L12 60 L32 35 Z" fill="${primary}" stroke="${secondary}" stroke-width="3" stroke-linejoin="round"/>
            <!-- İkinci Katman (Orta Zırh) -->
            <path d="M50 15 L62 38 L78 60 L82 78 L68 72 L50 82 L32 72 L18 78 L22 60 L38 38 Z" fill="${secondary}" opacity="0.4"/>
            <!-- Merkez Gövde -->
            <path d="M50 20 L60 65 L50 78 L40 65 Z" fill="${primary}" stroke="${secondary}" stroke-width="2"/>
            <!-- Kanat Detayları ve Silah/Sensör Çıkıntıları -->
            <line x1="12" y1="60" x2="32" y2="35" stroke="${accent}" stroke-width="2" opacity="0.6"/>
            <line x1="88" y1="60" x2="68" y2="35" stroke="${accent}" stroke-width="2" opacity="0.6"/>
            <circle cx="28" cy="68" r="3" fill="${engine}"/>
            <circle cx="72" cy="68" r="3" fill="${engine}"/>
            <!-- Köprü / Dev Kokpit -->
            <path d="M50 35 L58 50 L50 58 L42 50 Z" fill="${accent}" stroke="#fff" stroke-width="1.5"/>
            <path d="M50 38 L55 50 L50 56 Z" fill="#fff" opacity="0.7"/>
        `;
    }

    // Gölgelendirme filtresi ile gemiyi arka plandan hafifçe ayırarak 3D hissi katıyoruz
    const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 115" width="100%" height="100%">
            <defs>
                <filter id="drop-shadow" x="-20%" y="-20%" width="140%" height="140%">
                    <feDropShadow dx="0" dy="4" stdDeviation="3" flood-color="#000" flood-opacity="0.15" />
                </filter>
            </defs>
            <g filter="url(#drop-shadow)">
                ${svgContent}
            </g>
        </svg>
    `;
    return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
};

// Puan durumuna göre evrimleştirir ve sistemde kalan bozuk isimleri düzeltir
export const getCurrentPokemonId = (baseId, score) => {
    let normalizedId = baseId;
    
    // Eski sistemden kalan verileri güvenli başlangıç gemilerine aktarır
    const oldDataMap = {
        "Maden Sondası": "Maden Dronu",
        "Asteroit Kazıcı Gemisi": "Asteroit Kazıcı",
        "Ağır Maden Kruvazörü": "Dev Maden Gemisi",
        "Kalkan Jeneratörü": "Savunma Gemisi",
        "Kozmik Yağmacı": "Kozmik Yağmacı Gemisi"
    };

    if (typeof baseId === "number" || !isNaN(baseId)) {
        normalizedId = "Keşif Sondası";
    } else if (oldDataMap[baseId]) {
        normalizedId = oldDataMap[baseId];
    }

    const chain = EVOLUTION_CHAINS.find(c => c.includes(normalizedId));
    
    if (!chain) {
        normalizedId = "Keşif Sondası";
    } else {
        normalizedId = chain[0];
    }

    // Puan Mantığı: 0-9 Puan: Başlangıç | 10-19: Orta Aşama | 20+: Zirve Aşama
    const activeChain = EVOLUTION_CHAINS.find(c => c[0] === normalizedId);
    
    if (score >= 20) return activeChain[2];
    if (score >= 10) return activeChain[1];
    return activeChain[0];
};